export default __webpack_public_path__ + "static/media/DeliveryCart.636da142.svg";